import { first } from 'lodash'
import { useRecoilValue } from 'recoil'

import { hoveredItemsState } from './state'
import { HoveredItem, LayerFilter } from './types'
import { getFilteredFeatures } from './utils'

export interface UseHoveredItemsOpts {
  layerFilter?: LayerFilter
  onlyIfToplayer?: boolean
}

export function useHoveredItems(opts?: UseHoveredItemsOpts): HoveredItem[] {
  const { layerFilter, onlyIfToplayer } = opts || {}
  const features = useRecoilValue(hoveredItemsState)

  if (onlyIfToplayer) {
    const firstFeature = first(features)
    return getFilteredFeatures(firstFeature ? [firstFeature] : [], layerFilter)
  }

  return getFilteredFeatures(features, layerFilter)
}

export function useHoveredItem(
  opts?: UseHoveredItemsOpts,
): HoveredItem | undefined {
  const features = useHoveredItems(opts)

  return first(features)
}
